import timePeriodList from './time-none';

export default [...timePeriodList,];